import { gql } from '@apollo/client';

import { RecordSchemaOperationQuery as RecordSchemaOperation } from 'core/graphql';

import { useQuery } from './useQuery';

const RECORD_SCHEMA_QUERY = gql`
  query RecordSchemaOperation {
    recordSchema(recordType: "record")
  }
`;

/**
 * This hook is used to retrieve the Record schema from the server. See
 * `useQuery` for the expected return type.
 */
export const useRecordSchema = () =>
  useQuery<RecordSchemaOperation>(RECORD_SCHEMA_QUERY);
